import slice from "./slice";
export default slice.reducer;
